import { S } from "../styles";

export function TokenCell({
  prompt,
  completion,
}: {
  prompt: number | null;
  completion: number | null;
}) {
  if (prompt === null && completion === null)
    return <span style={S.muted}>—</span>;
  return (
    <span style={{ fontSize: 12, fontVariantNumeric: "tabular-nums" }}>
      <span style={{ color: "#4f46e5" }}>{(prompt ?? 0).toLocaleString()}</span>
      {" + "}
      <span style={{ color: "#7c3aed" }}>
        {(completion ?? 0).toLocaleString()}
      </span>
    </span>
  );
}
